import { z } from 'zod';
import { emailSchema } from './email.js';

export const changeEmailSchema = z.object({
  new_email: emailSchema(),
  password: z.string().min(1, 'Password is required for email change'),
});

export type ChangeEmailPayload = z.infer<typeof changeEmailSchema>;
